import api from "@/services/axios.js";
import {
  ReturnToDriverRequest,
  ReturnToDriverRequestPayload,
} from "../../types.ts";
import { searchHandler } from "../../lib/helpers.ts";

export const returnAcceptedVerificationToDriver = (
  request: ReturnToDriverRequest,
) => {
  const payload: ReturnToDriverRequestPayload = {};

  if (request.selectingAll) {
    payload.searchVerificationsRequestViewModel = searchHandler(
      request.searchValues,
    );
  } else {
    payload.verificationIds = request.verificationIds;
  }

  return api.put(
    "/api/AdminVerification/return-accepted-verification-to-driver",
    payload,
  );
};
